import { useEffect, useState } from "react";
import { getNltdevskeletonsUseCase } from "../useCases/getNltdevskeletonsUseCase";
import { useTable } from "src/hooks/useTable";
import { useDebounce } from "src/hooks/useDebounce";

export const useNltdevskeletonsTable = () => {
    const [loading, setLoading] = useState(false);
    const { rowsPerPage, page, search, onSearch, onChangePage, onChangeRowsPerPage, scrollRef } = useTable();

    useEffect(() => {
        onGetList();
    }, [rowsPerPage, page])

    useEffect(() => {
        debouncedWrapper();
    }, [search])

    const onGetList = async () => {
        if (!loading) {
            setLoading(true);
            await getNltdevskeletonsUseCase({ limit: rowsPerPage, offset: page * rowsPerPage, search });
            setLoading(false);
        }
    }

    const { debouncedWrapper } = useDebounce(onGetList, 500)

    return { rowsPerPage, page, search, onSearch, onChangePage, onChangeRowsPerPage, scrollRef };

}